<template>
  <v-date-picker
    ref="datepicker"
    v-model="pickerModel"
    color="green"
    :mode="mode"
    :min-date="minDate"
    :max-date="maxDate"
    v-on="$listeners"
    :input-props="{
      placeholder,
      disabled,
      class: {
        'form-control': true,
        'is-invalid': $attrs.state === false
      }  
    }"
    :popover="{
      visibility: 'focus'  
    }"
    :locale="{
      id: 'en',
      masks: {
        input: 'MM/DD/YYYY',
        data: 'MM/DD/YYYY'
      }  
    }"
  >
  <template v-slot="{ inputValue, inputEvents }">
    <input
      class="form-control"
      @keydown="hidePopup()"
      placeholder="Select date"
      :value="inputValue"
      @click="hidePopup(true)"
      v-on="inputEvents" 
    />
  </template>
  </v-date-picker>
</template>
<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import moment from "moment";

export default {
  name: 'DatePicker',
  components: {
    'v-date-picker': DatePicker
  },
  data() {
    return {
      pickerModel: null
    }
  },
  props: {
    value: {
      type: [String, Date]
    },
    mode: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String
    },
    minDate: {
      type: Date,
      default() {
        return new Date(1910, 0);
      }
    },
    maxDate: {
      type: Date
    }
  },
  methods: {
    hidePopup(click = false) {
      if (click) {
        this.$refs.datepicker.$children[0].show();
        return;
      }

      this.$refs.datepicker.$children[1].hide();
    },
    updateModel(value) {
      if (!value) return;

      this.pickerModel = moment(value).toDate();
    }
  },
  created() {
    this.updateModel(this.value);
  },
  watch: {
    pickerModel(to) {
      this.$emit('input', moment(to).format('MM/DD/YYYY'));
    } 
  }
}
</script>